<template>
  <BuilderWrapper title="Halo Bubbles">
    <!-- Halo Bubble -->
    <!-- Pulsing Bubble -->

    <CustomBubblesGroupSettings />

    <b-card
      v-if="haloBubbles.length === 0"
      no-body
    >
      <template #header>
        <b-row class="justify-content-end align-items-center">
          <b-col cols="5">
            <b-button
              variant="outline-primary"
              block
              @click="$typedStore.primary.app.addHaloConfig"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-card>

    <b-card
      v-for="(haloBubble, index) in haloBubbles"
      :key="`halo-bubble-config-${haloBubble.id}`"
      :class="{ 'mb-2': index !== haloBubbles.length - 1 }"
    >
      <template
        v-if="index === 0"
        #header
      >
        <b-row class="justify-content-end align-items-center">
          <b-col cols="5">
            <b-button
              variant="outline-primary"
              block
              @click="$typedStore.primary.app.addHaloConfig"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
          </b-col>
        </b-row>
      </template>

      <template #footer>
        <b-row class="justify-content-end align-items-center">
          <b-col cols="5">
            <b-button
              variant="outline-danger"
              block
              @click="$typedStore.primary.app.removeHaloConfig(haloBubble)"
            >
              <font-awesome-icon icon="trash-alt" />
            </b-button>
          </b-col>
        </b-row>
      </template>

      <HaloBubbleSettings
        :value="haloBubble"
        @input="$typedStore.primary.app.updateHaloBubble({ value: $event, index })"
      />
    </b-card>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import CustomBubblesGroupSettings from '@/components/builder/CustomBubblesGroup/CustomBubblesGroupSettings.vue'
import HaloBubbleSettings from '@/components/builder/HaloBubbles/HaloBubbleSettings.vue'

const components = {
  BuilderWrapper,
  HaloBubbleSettings,
  CustomBubblesGroupSettings,
}

// eslint-disable-next-line no-use-before-define
@Component<HaloBubblesSettings>({
  components,
})
export default class HaloBubblesSettings extends Vue {
  get customBubblesGroups () {
    return this.$typedStore.primary.app.config.customBubblesGroups
  }

  get customBubblesGroupsList () {
    return Object.entries(this.customBubblesGroups)
  }

  get haloBubbleFilterOptions () {
    return [
      { text: 'None', value: null },
      ...this.customBubblesGroupsList.map(([id, { name }]) => {
        return { text: name, value: id }
      }),
    ]
  }

  get haloBubbles () {
    return this.$typedStore.primary.app.config.haloBubbles
  }
}

</script>
